import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Moment from "react-moment";
import { getTotalHours } from "../../Services/appService";

const CANDIDATE_PAY_STYLES = {
  modalContent: {
    borderRadius: "24px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)",
  },
  modalDialog: {
    maxWidth: "920px",
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)",
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
  },
  modalFooter: {
    padding: "16px 22px 20px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "15px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "21px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)",
  },
  title: {
    fontSize: "22px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0,
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 800,
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
    flexShrink: 0,
  },
  modalBody: {
    padding: "20px 22px 22px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
  },
  helperCard: {
    borderRadius: "16px",
    padding: "16px",
    background: "linear-gradient(135deg, rgba(248,250,252,0.98) 0%, rgba(239,246,255,0.9) 100%)",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px",
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "8px",
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0,
  },
  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
    gap: "14px",
    marginBottom: "16px",
  },
  summaryCard: {
    borderRadius: "18px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "16px",
  },
  summaryLabel: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "8px",
  },
  summaryValue: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "20px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.15,
  },
  summaryIcon: {
    width: "30px",
    height: "30px",
    borderRadius: "11px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eff6ff",
    color: "#1d4ed8",
    border: "1px solid rgba(191, 219, 254, 1)",
    fontSize: "13px",
    flexShrink: 0,
  },
  detailsCard: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px",
    marginBottom: "16px",
  },
  detailsTitle: {
    fontSize: "15px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "14px",
  },
  detailGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
    gap: "12px",
  },
  detailItem: {
    borderRadius: "14px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#f8fbff",
    padding: "12px 14px",
  },
  detailLabel: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "6px",
  },
  detailValue: {
    fontSize: "13px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.45,
    minHeight: "19px",
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  },
  closeAction: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#475569",
    padding: "10px 14px",
    fontSize: "12px",
    fontWeight: 800,
  },
};

const formatMoney = (value) => {
  const amount = Number(value || 0);
  return amount.toFixed(2);
};

const CandidatePay = (props) => {
  const { selectedObj, candidateObj, handlePayShowHide, payShowHide, timeLogsData, grossPay, netPay } = props;
  const [invAmount, setInvAmount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);

  useEffect(() => {
    if (selectedObj && candidateObj) {
      if (grossPay !== undefined && netPay !== undefined) {
        setInvAmount(grossPay);
        setFinalAmount(netPay);
        return;
      }

      const selectedTimeLog = timeLogsData?.find((log) => log.id === selectedObj.timeLogId);
      const workingHours = getTotalHours(selectedTimeLog?.workingHrs || 0);
      const invAmt = (candidateObj?.rates?.subcontractorRate || 0) * (workingHours || 0);
      let fAmt = invAmt;

      if (selectedObj.adjustmentMinues) {
        fAmt -= selectedObj.adjustmentMinues;
      }

      if (selectedObj.adjustmentPlus) {
        fAmt += selectedObj.adjustmentPlus;
      }

      setInvAmount(invAmt);
      setFinalAmount(fAmt);
    }
  }, [selectedObj, candidateObj, timeLogsData, grossPay, netPay]);

  const paidDate = selectedObj?.paymentDate || selectedObj?.addedDatetime;

  return (
    <Modal
      show={payShowHide}
      size="xl"
      centered
      onHide={() => handlePayShowHide("")}
      dialogClassName="candidate-pay-modal-dialog"
      contentClassName="candidate-pay-modal-content"
    >
      <style>{`
        .candidate-pay-modal-dialog {
          max-width: ${CANDIDATE_PAY_STYLES.modalDialog.maxWidth};
        }
        .candidate-pay-modal-content {
          border-radius: ${CANDIDATE_PAY_STYLES.modalContent.borderRadius};
          overflow: ${CANDIDATE_PAY_STYLES.modalContent.overflow};
          border: ${CANDIDATE_PAY_STYLES.modalContent.border};
          box-shadow: ${CANDIDATE_PAY_STYLES.modalContent.boxShadow};
        }
      `}</style>

      <Modal.Header style={CANDIDATE_PAY_STYLES.modalHeader}>
        <div style={CANDIDATE_PAY_STYLES.headerContent}>
          <Modal.Title as="div" style={CANDIDATE_PAY_STYLES.titleWrap}>
            <div style={CANDIDATE_PAY_STYLES.headerIcon}>
              <i className="fa fa-money" aria-hidden="true"></i>
            </div>
            <div>
              <div style={CANDIDATE_PAY_STYLES.title}>Payment Details</div>
              <div style={CANDIDATE_PAY_STYLES.subtitle}>
                Review gross pay, adjustments, payment mode, and final net payment.
              </div>
            </div>
          </Modal.Title>
          <button
            type="button"
            style={CANDIDATE_PAY_STYLES.closeButton}
            onClick={() => handlePayShowHide("")}
            aria-label="Close payment details"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </Modal.Header>

      <Modal.Body style={CANDIDATE_PAY_STYLES.modalBody}>
        <div style={CANDIDATE_PAY_STYLES.helperCard}>
          <div style={CANDIDATE_PAY_STYLES.helperTitle}>Payment summary</div>
          <p style={CANDIDATE_PAY_STYLES.helperText}>
            This view summarizes the payment calculation and the recorded payment information for the selected invoice period.
          </p>
        </div>

        <div style={CANDIDATE_PAY_STYLES.summaryGrid}>
          <div style={CANDIDATE_PAY_STYLES.summaryCard}>
            <div style={CANDIDATE_PAY_STYLES.summaryLabel}>Gross Pay</div>
            <div style={CANDIDATE_PAY_STYLES.summaryValue}>
              <span style={CANDIDATE_PAY_STYLES.summaryIcon}><i className="fa fa-usd"></i></span>
              {formatMoney(invAmount)}
            </div>
          </div>
          <div style={CANDIDATE_PAY_STYLES.summaryCard}>
            <div style={CANDIDATE_PAY_STYLES.summaryLabel}>Net Pay</div>
            <div style={CANDIDATE_PAY_STYLES.summaryValue}>
              <span style={CANDIDATE_PAY_STYLES.summaryIcon}><i className="fa fa-check"></i></span>
              {formatMoney(finalAmount)}
            </div>
          </div>
          <div style={CANDIDATE_PAY_STYLES.summaryCard}>
            <div style={CANDIDATE_PAY_STYLES.summaryLabel}>Paid Amount</div>
            <div style={CANDIDATE_PAY_STYLES.summaryValue}>
              <span style={CANDIDATE_PAY_STYLES.summaryIcon}><i className="fa fa-credit-card"></i></span>
              {formatMoney(selectedObj?.paidAmount)}
            </div>
          </div>
        </div>

        <div style={CANDIDATE_PAY_STYLES.detailsCard}>
          <div style={CANDIDATE_PAY_STYLES.detailsTitle}>Payment Breakdown</div>
          <div style={CANDIDATE_PAY_STYLES.detailGrid}>
            <div style={CANDIDATE_PAY_STYLES.detailItem}>
              <div style={CANDIDATE_PAY_STYLES.detailLabel}>Date Paid</div>
              <div style={CANDIDATE_PAY_STYLES.detailValue}>
                {paidDate ? <Moment format="MMM Do YYYY">{paidDate}</Moment> : "-"}
              </div>
            </div>
            <div style={CANDIDATE_PAY_STYLES.detailItem}>
              <div style={CANDIDATE_PAY_STYLES.detailLabel}>Payment Mode</div>
              <div style={CANDIDATE_PAY_STYLES.detailValue}>{selectedObj?.paymentMode || "-"}</div>
            </div>
            <div style={CANDIDATE_PAY_STYLES.detailItem}>
              <div style={CANDIDATE_PAY_STYLES.detailLabel}>Adjustment Plus (+)</div>
              <div style={CANDIDATE_PAY_STYLES.detailValue}>{formatMoney(selectedObj?.adjustmentPlus)}</div>
            </div>
            <div style={CANDIDATE_PAY_STYLES.detailItem}>
              <div style={CANDIDATE_PAY_STYLES.detailLabel}>Adjustment Minus (-)</div>
              <div style={CANDIDATE_PAY_STYLES.detailValue}>{formatMoney(selectedObj?.adjustmentMinues)}</div>
            </div>
          </div>
        </div>


      </Modal.Body>
      <Modal.Footer style={CANDIDATE_PAY_STYLES.modalFooter}>
        <div style={CANDIDATE_PAY_STYLES.footerActions}>
          <button
            type="button"
            style={CANDIDATE_PAY_STYLES.closeAction}
            onClick={() => handlePayShowHide("")}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
            Close
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CandidatePay;
